import PostFilter from '@js/partials/postFilter';
import PostFilterLoad from '@js/partials/postFilterLoad';

export default {
  init() {
    PostFilter.init();
    PostFilterLoad.init();
  },
};
